import type { Content } from '@generalTypes/apiTypes';
import {
  AsyncKovResourcePicker,
  Modal,
  useLoadSriOptions,
} from '@kathondvla/react-shared-components/src/components';
import { formatDate } from '@newStore/genericHelpers';
import { contentApi } from '@store/api/apiConfig';
import type React from 'react';
import { useState } from 'react';

export interface ZillCurriculumSelectorModalProps {
  onClose?: () => void;
  onSubmit?: (selectedDocument: Content | null) => void;
  params: {
    type: 'CURRICULUM_ZILL';
    issuedBefore: Date;
    orderBy: string;
    descending: boolean;
  };
}

const DisplayOption = ({ item }) => {
  return (
    <div className="picker-result">
      <img src="/images/zill.svg" alt="image" className="thumb" />
      <strong className="title">{item.title}</strong>
      <br />
      {item.$$relationsTo.some((r) => r.$$expanded.relationtype === 'REPLACES') && (
        <span className="label label-danger">VORIGE VERSIE</span>
      )}
      &nbsp;
      <span className="subtitle">
        {item.issued ? formatDate(item.issued) : 'Niet gepubliceerd'}
      </span>
    </div>
  );
};

const ZillCurriculumSelectorModal: React.FC<ZillCurriculumSelectorModalProps> = ({
  onClose = () => {},
  onSubmit,
  params,
}) => {
  const sriLoadOptionsFn = useLoadSriOptions({
    sriClient: contentApi,
    href: '/content',
    parameters: params,
  });

  const [selectedDocument, setSelectedDocument] = useState<Content | null>(null);

  const handleChange = (value) => {
    setSelectedDocument(value);
  };

  const handleSubmit = () => {
    if (onSubmit) {
      onSubmit(selectedDocument);
      onClose();
    }
  };

  return (
    <div className="overflown-modal">
      <Modal.Header title="Selecteer ZILL versie" onClose={onClose} />
      <Modal.Body>
        <div className="form-group">
          <div className="row">
            <div className="col-md-12">
              <label>Document:</label>
              <AsyncKovResourcePicker
                value={selectedDocument}
                loadOptions={sriLoadOptionsFn}
                localData={true}
                clearable={false}
                disabled={false}
                onChange={(value) => handleChange(value.$$expanded)}
                placeholder="Selecteer een ZILL versie"
                multiple={false}
                menuPlacement="bottom"
                optionValue={(o) => o.key}
                optionTemplate={(o) => <DisplayOption item={o?.$$expanded || o} />}
              />
            </div>
          </div>
        </div>
      </Modal.Body>
      <Modal.Footer>
        <button className="btn btn-link pull-left" onClick={onClose}>
          Annuleren
        </button>
        <button className="btn btn-primary" onClick={handleSubmit}>
          Gebruik versie
        </button>
      </Modal.Footer>
    </div>
  );
};

ZillCurriculumSelectorModal.displayName = 'ZillCurriculumSelectorModal';

export default ZillCurriculumSelectorModal;
